import React from 'react';
import { Question } from '../types';

interface QuestionDisplayProps {
  question: Question;
}

const QuestionDisplay: React.FC<QuestionDisplayProps> = ({ question }) => {
  return (
    <div className="flex flex-col items-center">
      <div className="text-4xl sm:text-5xl font-bold text-slate-800 dark:text-slate-100 my-6 flex items-center gap-4">
        {question.operation === 'multiplication' ? (
          <>
            <span>{question.multiplicand}</span>
            <span className="text-indigo-600 dark:text-indigo-400">×</span>
            <span>{question.multiplier}</span>
          </>
        ) : (
          <>
            <span>{question.multiplicand}</span>
            <span className="text-indigo-600 dark:text-indigo-400">÷</span>
            <span>{question.multiplier}</span>
          </>
        )}
        <span className="text-indigo-600 dark:text-indigo-400">=</span>
        <span className="text-transparent">?</span>
      </div>
    </div>
  );
};

export default QuestionDisplay;